export default {
  'ticket.operator': 'オペレーター',
  'ticket.status': '状態',
  'ticket.lastupdate': '最終アップデート',
  'ticket.ticketid': 'リクエストID',
  'ticket.subject': '件名',
  'ticket.total': 'リクエストの総計',
  'ticket.notassigned': '割り当てられていません',
  'ticket.addnewticket': '新しいリクエスト',
  'ticket.search': '検索',
  'ticket.knowleadgebase': '知識ベース',
  'ticket.announcements': 'アナウンス',
  'ticket.description': '説明',
  'ticket.mytickets': 'リクエスト',
  'ticket.knowledgebase': '知識ベース',
  'ticket.all': 'すべて　　　　',
  'ticket.done': '完了',
  'ticket.inprogress': '進行中',
  'ticket.new': '新',
  'ticket.ticketsInbox': '受信箱',
  'ticket.ticketsUnread': '未読',
  'ticket.send': '送信',
  'ticket.close': '閉じる',
  'ticket.ticketType': 'リクエストタイプ',
  'ticket.sender': '差出人',
  'ticket.findtickets': 'リクエストの検索',
  'ticket.newticket': '新しいリクエスト',
  'ticket.uploadYourImage': 'イメージのアップロード',
  'ticket.indertSuccessFully': 'リクエストが完了しました',
  'ticket.notAssigned': '割り当てられていません',
  'ticket.text': 'テキスト',
  'ticket.insertSubject': 'リクエストの件名を記入してください',
  'ticket.insertText': 'リクエストの本文を記入してください',
  'ticket.insertMessageAndSubject': 'リクエストの本文と件名を入力してください',
  'ticket.details': '詳細',
  'ticket.reply': '応答',
  'ticket.dateoforder': '注文日',
  'ticket.dateoftravel': '旅行日',
  'ticket.item': 'アイテム',
  'ticket.submitinwriting': '書面で提出する',
  'ticket.send': '送信',
  'ticket.attachphoto':
    'リクエストセクションのこの部分では、下のリンクからご希望の写真をアップロードできます。',
};
